import HomeModule, { CoinGeckoMark } from './HomeModule';

/* Keresési népszerűség (CoinGecko) — a CoinGecko „trending” listája: amit a
   CoinGecko-n az elmúlt 24 órában a legtöbben kerestek. Nem ár- vagy forgalmi rangsor. */
export default function HomeTrending({ trendingData, meta, user, expectedMs, onRetry }) {
  const items = trendingData?.coins?.slice(0, 5) ?? [];
  return (
    <HomeModule id="trending" title="Keresési népszerűség" user={user}
      info="Azok a coinok, amelyekre a CoinGecko oldalán az elmúlt 24 órában a legtöbben kerestek. Népszerűséget mér, nem árat vagy forgalmat."
      source="CoinGecko (trending)" attr={<CoinGeckoMark />} at={meta?.at} expectedMs={expectedMs} stale={meta?.stale} error={!!meta?.error}
      errorText={meta?.error || 'A CoinGecko most nem elérhető'} onRetry={onRetry} className="htr">
      {items.length === 0 ? <div className="hev-empty">…</div> : (
        <ol className="htr-list">
          {items.map(({ item: c }, i) => (
            <li key={c.id} className="htr-row">
              <span className="htr-rank num">{i + 1}.</span>
              <img src={c.small || c.thumb} alt="" className="htr-ic" onError={e => { e.target.style.visibility = 'hidden'; }} />
              <span className="htr-name">{c.name}</span>
              <span className="htr-sym">{String(c.symbol || '').toUpperCase()}</span>
            </li>
          ))}
        </ol>
      )}
    </HomeModule>
  );
}
